export default __webpack_public_path__ + "8ec2d7dbd1d243baed82fc373a75d316.svg";